import * as React from "react"
import { Color, colors } from "../../master"

type ProductColorProps = {
  currentColor: string,
  colorId: string,
  onMouseEnter: { (): void },
}

export const ProductColor: React.FC<ProductColorProps> = ({currentColor, colorId, onMouseEnter}) => {
  const color: Color = colors.filter(({id}) => id === colorId)[0]
  const style = {
    backgroundColor: color.colorCode
  }

  return (
    <div className="grid gap-2 mb-3 lg:h-8 lg:mx-1" onMouseEnter={onMouseEnter}>
      <div
        className={`w-4 h-4 m-auto rounded-full border-white border box-content cursor-pointer lg:border-2 lg:border-white${currentColor === colorId ? ' lg:border-blue-100' : ''}`}
        style={style}
        title={color.name}
      />
      <div className="text-center lg:hidden" style={{fontSize: "10px"}}>
        {color.name}
      </div>
    </div>
  )
}
